import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { flatRatePlanNames } from "@common/flatRateBilling";
import { formatFilterLabel } from "./formatFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const PlanFilterLabel: React.FC<Props> = ({ filters }) => {
    const { plans } = filters;

    if (!plans || plans.length === 0) {
        return null;
    }

    const labels = plans.map((plan) => flatRatePlanNames[plan]);
    return formatFilterLabel(labels);
};
